import getUserDisplayName from "helpers/userHelper";
import { useIntl } from "react-intl";
import { OrganizationUserDetails } from "services/KnowfullyAdminClient";
import useTitle from "./useTitle";

export default function useFormattedTitleFromUser(
  labelId: string,
  user?: OrganizationUserDetails,
  defaultValue?: string
) {
  const { formatMessage } = useIntl();
  const name = getUserDisplayName(user, defaultValue);
  return useTitle(formatMessage({ id: labelId }, { name }));
}
